import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  fill: "none",
  version: "1.1",
  id: "svg1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:svg": "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M 3.6304891,14.659895 H 12.454014 M 8.0422507,1.4246085 V 11.71914 M 4.3653621,8.0422505 8.0422507,11.71914 11.719138,8.0422505",
      stroke: "#020617",
      "stroke-width": "1.76471",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      id: "path1"
    }, null, -1)
  ]))]))
}
export default { render: render }